import {
  getFailed,
  getStarted,
  getSucceeded,
  getEnded,
  statusEnum,
  FORGOT_PASSWORD_SET_DEFAULT,
  FORGOT_PASSWORD_SUBMIT,
  ON_CHANGE_FORGOT_PASSWORD_FORM,
} from "../actions/constant";

const initialState = {
  isLoading: false,
  status: statusEnum.DEFAULT,
  actionResponse: null,
  emailField: "",
};

// Forgot password reducer
function reducer(state = initialState, action) {
  switch (action.type) {
    case FORGOT_PASSWORD_SET_DEFAULT:
      return {
        ...state,
        isLoading: false,
        status: statusEnum.DEFAULT,
        actionResponse: null,
        emailField: "",
        passResetFailed: false,
      };
    case getStarted(FORGOT_PASSWORD_SUBMIT):
      return {
        ...state,
        actionResponse: null,
        passResetFailed: false,
        isLoading: true,
      };
    case getSucceeded(FORGOT_PASSWORD_SUBMIT):
      return {
        ...state,
        // status: statusEnum.SUCCESS,
        passResetSuccess: true,
      };
    case getFailed(FORGOT_PASSWORD_SUBMIT):
      return {
        ...state,
        actionResponse: action.payload,
        // status: statusEnum.ERROR,
        passResetFailed: true,
      };
    case getEnded(FORGOT_PASSWORD_SUBMIT):
      return { ...state, isLoading: false };

    case ON_CHANGE_FORGOT_PASSWORD_FORM:
      state.emailField = action.value;

      return { ...state, isLoading: false };

    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/forgotPasswordReducer.js